import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-link.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const LinkIcon = createSvgIcon(<Icon />, 'LinkIcon');
